import { useRef } from 'preact/hooks';
import { Portal } from '@/components';
import { useProperties, useFormProps, useConfigStore } from '../stores/ConfigStore';
import { useFormStore } from '../stores/FormStore';
import { windowBoxShadow } from './Form';
import FormWindow from './FormWindow';
import FeedbackButton from './FeedbackButton';
import CloseButton from './CloseButton';
import BaseForm from './BaseForm';
import LanguageToggle from './LanguageToggle';

export default function ModalForm() {
	const {
		feedbackButtonRef,
		closeButtonRef,
		formBodyRef,
		frameRef,
		wrapStyle,
		formOpen,
		screenshotActive,
		formType,
		actions: formActions
	} = useFormStore();
	const { translation = {} } = useProperties();
	const { formKey } = useFormProps();
	const { themeClass } = useConfigStore();
	const wrapRef = useRef(null);
	const isIOS =
		navigator.userAgent.match(/(iPod|iPhone|iPad)/gi) ||
		(navigator.userAgent.match(/safari/gi) && navigator.maxTouchPoints > 1);

	return (
		<div
			className={`mopinion-survey-content wcag ${themeClass}`}
			data-mop-form-type={formType}
		>
			<Portal into={document.body}>
				<div
					className={`mopinion-survey-content ${themeClass}`}
					data-mop-form-type={formType}
				>
					<div
						ref={wrapRef}
						id="surveyWindowWrap"
						className={`surveyWindowWrap ${
							screenshotActive ? 'screen-capture-active' : ''
						}`}
						data-parent-for={formKey}
						style={wrapStyle}
						onClick={e => {
							if (e.target.isEqualNode(wrapRef.current)) {
								formActions.toggleForm();
							}
						}}
						onKeyDown={e => formActions.handleWCAGkeyEvents(e)}
					>
						<FormWindow
							style={{
								position: 'absolute',
								top: '50px',
								left: 0,
								right: 0,
								marginLeft: 'auto',
								marginRight: 'auto',
								maxWidth: '480px',
								marginBottom: 50,
								boxShadow: windowBoxShadow,
								background: 'rgb(255,255,255)',
								transition: 'transform .225s, opacity .225s, height .175s',
								transform: formOpen ? 'scale(1)' : 'scale(.95)',
								opacity: formOpen ? 1 : 0
							}}
							ref={frameRef}
						>
							<div
								id="surveyBody"
								style={{ overflow: 'hidden' }}
								role="dialog"
								aria-labelledby={`surveyTitle-${formKey}`}
								ref={formBodyRef}
							>
								<CloseButton ref={closeButtonRef} />
								{translation?.useTranslation && translation?.useToggle && (
									<LanguageToggle />
								)}
								<BaseForm />
							</div>
						</FormWindow>
						<div style={isIOS ? { height: 'calc(100vh + 1px)' } : {}} />
					</div>
				</div>
			</Portal>

			<FeedbackButton ref={feedbackButtonRef} />

			<Portal into={document.body}>
				<div
					data-mask-for={formKey}
					class={`mopinion-survey-mask wcag ${
						screenshotActive ? 'screen-capture-active' : ''
					}`}
					id="surveyMask"
					style={{
						pointerEvents: formOpen ? 'auto' : 'none',
						opacity: formOpen ? 0.15 : 0,
						visibility: formOpen ? 'visible' : 'hidden',
						transition: 'opacity .225s, visibility .225s',
						zIndex: !formOpen ? -1 : 1999999998
					}}
				/>
			</Portal>
		</div>
	);
}
